module.exports = __webpack_public_path__ + "static/media/nw.2554265f.svg";